module.exports = __webpack_public_path__ + "img/antes_despues_127.5f8327e4.png";